import {
  Box,
  Grid,
  Typography,
  Divider,
  FormHelperText,
  Link,
} from '@mui/material';
import { FieldMetaProps } from 'formik';
import additionalInfo from '../../../config/aditionalInformation.json';
import TooltipReusable from 'src/components/TooltipReusable';
import TooltipReusableWhiteBg from 'src/components/TooltipReusableWhiteBg';
import { useAppSelector } from 'src/utils/hooks';

interface Props {
  question: Question;
  children: JSX.Element | JSX.Element[];
  meta?: FieldMetaProps<any>;
  percentage?: number;
}

export default function QuestionLayout({
  question: q,
  children,
  meta,
  percentage,
}: Props) {
  const [info] = additionalInfo.filter(
    (question) => question.questionId === q.key
  );
  const { isColorBlindMode } = useAppSelector((state) => state.config);
  const getQuestionText = () => {
    let text = '';

    if (isColorBlindMode && q.key === 'avoidAdvice') {
      return "<b>Verzicht auf Beratung:</b><br><br><b>Im Zuge des Onlineantrages verzichte ich auf die angebotene fachliche Beratung und deren Dokumentation. Mir ist bewusst, welche Bedeutung einer Beratung in Versicherungsfragen zukommt und, dass sich der Verzicht nachteilig darauf auswirken kann, zu einem späteren Zeitpunkt Schadensersatzansprüche gegen den Versicherer geltend zu machen.</b><br><br><span style='color: #0066B3;'>Das bedeutet:</span><br><span style='color: #0066B3;'>• Ich möchte keine Beratung zu meinem Online-Antrag.</span><br><span style='color: #0066B3;'>• Auch keine Aufzeichnung der Beratung.</span><br><span style='color: #0066B3;'>• Ich weiß, dass eine Beratung wichtig ist für Versicherungen.</span><br><span style='color: #0066B3;'>• Ich weiß, dass es schlecht für mich sein kann, wenn ich keine Beratung habe.</span><br><span style='color: #0066B3;'>Zum Beispiel, wenn ich später Geld von dem Versicherungs-Unternehmen haben möchte (Schadensersatz).</span><br><b>Ich stimme zu, dass ich keine Beratung möchte.</b>";
    } else {
      text = q.text;
    }

    if (isColorBlindMode && q.key === 'adviceInformation') {
      text = text.replace('color: #0000EE', 'color: #000000');
    }

    return text;
  };

  const questionText = getQuestionText();
  return (
    <Box>
      <Divider sx={{ borderColor: isColorBlindMode ? '#000000' : undefined }} />

      <Grid container spacing={2} paddingY={1.5} alignItems="center">
        <Grid item xs={12}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <Typography
                fontWeight={q.html ? 'normal' : 'bold'}
                sx={{ wordBreak: 'break-word' }}
                {...(q.html
                  ? {
                      dangerouslySetInnerHTML: {
                        __html: questionText,
                      },
                    }
                  : {
                      children: (
                        <>
                          <span>{q.text}</span>

                          {info?.informationText &&
                            (isColorBlindMode ? (
                              <TooltipReusableWhiteBg
                                isHeader={true}
                                iconFlag={true}
                                width={350}
                                isBlackbg={true}
                                titleStyles={{
                                  color: '#0066B3',
                                  fontSize: '14px',
                                  fontWeight: 400,
                                }}
                                title={[info?.informationText]}
                              />
                            ) : (
                              <TooltipReusable
                                title={[info?.informationText]}
                              />
                            ))}
                        </>
                      ),
                    })}
              ></Typography>
            </Grid>
          </Grid>

          {q.helpText &&
            (q.helpText.includes('http') ? (
              <Link href={q.helpText} color="inherit" target="_blank">
                {q.helpText}
              </Link>
            ) : (
              <Typography
                pt={1.5}
                {...{
                  dangerouslySetInnerHTML: {
                    __html: q.helpText,
                  },
                }}
              ></Typography>
            ))}
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          width={'100%'}
          display={'flex'}
          alignItems={'center'}
        >
          {children}
        </Grid>
      </Grid>
      {meta ? (
        <FormHelperText sx={{ fontSize: 12 }} error>
          {meta.touched ? meta.error : ''}
        </FormHelperText>
      ) : null}
    </Box>
  );
}
